import { render } from "./Sorter.vue?vue&type=template&id=0206803a"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"

import "./Sorter.vue?vue&type=style&index=0&id=0206803a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__